import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteVehicleModelSchema = z.object({
  id: z.number(),
});

export const getVehicleModelsRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addVehicleModelSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  brandId: z.number({
    required_error: "La marque est requise",
    invalid_type_error: "La marque est requise",
  }),
});

export const editVehicleModelSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  brandId: z.number({
    required_error: "La marque est requise",
    invalid_type_error: "La marque est requise",
  }),
  isActive: z.boolean().default(true),
});
